import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Twitter, Instagram, Youtube } from 'lucide-react';

export const Footer: React.FC = () => {
  return (
    <footer className="bg-background-secondary">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div>
            <h3 className="text-lg font-bold text-text-primary mb-3">
              Dala Rides
            </h3>
            <p className="text-text-secondary mb-4 text-sm">
              Your trusted partner for unforgettable safari adventures in
              Tanzania.
            </p>
            <div className="flex gap-3">
              <a
                href="#"
                className="text-text-tertiary hover:text-primary-500 transition-colors"
              >
                <Facebook className="w-4 h-4" />
              </a>
              <a
                href="#"
                className="text-text-tertiary hover:text-primary-500 transition-colors"
              >
                <Twitter className="w-4 h-4" />
              </a>
              <a
                href="#"
                className="text-text-tertiary hover:text-primary-500 transition-colors"
              >
                <Instagram className="w-4 h-4" />
              </a>
              <a
                href="#"
                className="text-text-tertiary hover:text-primary-500 transition-colors"
              >
                <Youtube className="w-4 h-4" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-semibold text-text-primary mb-3 text-sm">
              Quick Links
            </h4>
            <ul className="space-y-1">
              <li>
                <Link
                  to="/about"
                  className="text-text-secondary hover:text-primary-500 transition-colors text-sm"
                >
                  About Us
                </Link>
              </li>
              <li>
                <Link
                  to="/safaris"
                  className="text-text-secondary hover:text-primary-500 transition-colors text-sm"
                >
                  Safari Tours
                </Link>
              </li>
              <li>
                <Link
                  to="/contact"
                  className="text-text-secondary hover:text-primary-500 transition-colors text-sm"
                >
                  Contact Us
                </Link>
              </li>
              <li>
                <Link
                  to="/blog"
                  className="text-text-secondary hover:text-primary-500 transition-colors text-sm"
                >
                  Blog
                </Link>
              </li>
            </ul>
          </div>

          {/* Support */}
          <div>
            <h4 className="font-semibold text-text-primary mb-3 text-sm">Support</h4>
            <ul className="space-y-1">
              <li>
                <Link
                  to="/faq"
                  className="text-text-secondary hover:text-primary-500 transition-colors text-sm"
                >
                  FAQ
                </Link>
              </li>
              <li>
                <Link
                  to="/terms"
                  className="text-text-secondary hover:text-primary-500 transition-colors text-sm"
                >
                  Terms & Conditions
                </Link>
              </li>
              <li>
                <Link
                  to="/privacy"
                  className="text-text-secondary hover:text-primary-500 transition-colors text-sm"
                >
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link
                  to="/cancellation"
                  className="text-text-secondary hover:text-primary-500 transition-colors text-sm"
                >
                  Cancellation Policy
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="font-semibold text-text-primary mb-3 text-sm">
              Contact Info
            </h4>
            <ul className="space-y-1 text-text-secondary text-sm">
              <li>123 Safari Street</li>
              <li>Arusha, Tanzania</li>
              <li>Phone: +255 123 456 789</li>
              <li>Email: info@dalarides.com</li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-border-primary mt-6 pt-2 pb-1 text-center text-text-tertiary text-xs">
          <p className="leading-tight">
            &copy; {new Date().getFullYear()} Dala Rides. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};
